<template>
  <v-alert type="color" :value="true" v-if="color">
    {{Value}}
  </v-alert>
  <span v-else> {{Value}}</span>

</template>

<style scoped>

</style>

<script>
  import DateCell from "./dateCell.ts";
  export default DateCell;
</script>